import { useContrastQuery } from '../../../../hooks/use-contrast-query'
import { LatestUsedCredentials } from './shared'
import { Query } from '../../../../hooks/queries'
import { HTTPError } from '../../../../api/fetch/decorate-fetch'
import { getCredentials, GetCredentialsArgs } from './requests/get-credentials'

export interface UseCredentialsQueryProps {
  organizationUuid: string
  bugtracker: 'JIRA' | 'AGILE_CENTRAL'
  disabled?: boolean
}

export interface CredentialsResponse {
  credentialsList: Array<LatestUsedCredentials> | undefined
  error: HTTPError | null
  isError: boolean
  isLoading: boolean
}

export type UseCredentialsQuery = (
  props: UseCredentialsQueryProps
) => CredentialsResponse

/** This returns the latest credentials but ALSO sets the credentials_id in the form */
export const useCredentialsQuery: UseCredentialsQuery = ({
  organizationUuid,
  bugtracker,
  disabled = false
}: UseCredentialsQueryProps) => {
  const {
    data: credentialsList,
    error,
    isError,
    isLoading
  } = useContrastQuery<GetCredentialsArgs, Array<LatestUsedCredentials>>(
    [Query.INTEGRATIONS_CREDENTIALS, organizationUuid, bugtracker],
    getCredentials,
    {
      organizationUuid,
      bugtracker
    },
    {
      enabled: !disabled,
      cacheTime: 0
    }
  )

  return {
    credentialsList,
    error,
    isError,
    isLoading
  }
}
